import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import check from "../../assets/images/workPreferences/check.png";
import line1 from "../../assets/images/workPreferences/line1.png";
import line2 from "../../assets/images/workPreferences/line2.png";
import line3 from "../../assets/images/workPreferences/line3.png";
import line4 from "../../assets/images/workPreferences/line4.png";
import women from "../../assets/images/workPreferences/women.png";
import men from "../../assets/images/workPreferences/men.png";
import {
  GET_GYM_PREFRENCES_ENDPOINT,
  POST_WORKOUT_PREFRENCES,
} from "../../config/ApisCollection";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";

export default function WorkoutTargetZone() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const [personImg, setPersonImg] = useState(null);
  const dispatch = useDispatch();
  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };
  const [gender] = useState("men");
  const [bodyOptions, setBodyOptions] = useState([]);
  const [selectedBodyOptions, setSelectedBodyOptions] = useState([]);
  const [bodyTarget, setBodyTarget] = useState([
    { name: "pecs", isTrue: false },
    { name: "belly", isTrue: false },
    { name: "buttocks", isTrue: false },
    { name: "legs", isTrue: false },
  ]);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const handleToggle = async (index) => {
    const updatedBodyTarget = bodyTarget.map((target, idx) =>
      idx === index ? { ...target, isTrue: !target.isTrue } : target
    );

    setBodyTarget(updatedBodyTarget);
  };

  const GetPrefrencesesData = async () => {
    let api_url = `${GET_GYM_PREFRENCES_ENDPOINT}`;

    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios.get(api_url, post_header).then((response) => {
        setBodyOptions(Object.entries(response.data));
        setPersonImg(response.data.backgroundimg);
        // console.log(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const PostPrefrencesData = async () => {
    const post_body = {
      targetzone: ["pecs", "belly", "buttocks"],
    };

    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(POST_WORKOUT_PREFRENCES, post_body, post_header)
        .then((response) => {
          console.log(response);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetPrefrencesesData();
  }, [bodyTarget]);
  console.log(bodyTarget);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        {/* <SideBarBack handleCloseDrawer={handleCloseDrawer} /> */}
      </div>
      <div className="text-center w-6/12 mt-2 mx-auto pb-8 gap-6 flex flex-col justify-between">
        <p className="text-2xl font-medium">
          What target zones do you want{" "}
          <span className="text-[#FF9950]"> to work on</span> ?
        </p>
        <div className="flex gap-6 w-full justify-center">
          {gender === "men" && personImg != null ? (
            <div className="relative w-[16%]">
              <img src={personImg} alt="workoutladey" />

              <div
                className="absolute w-[70%] flex items-center top-[3.5rem] -right-6"
                key={1}
              >
                <img src={line1} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[70%] flex items-center top-[8rem] -right-6"
                key={2}
              >
                <img src={line2} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[53%] flex items-center top-[10.7rem] -right-6"
                key={3}
              >
                <img src={line3} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[60%] flex items-center top-[15.9rem] -right-6"
                key={4}
              >
                <img src={line4} alt="workoutladey" />
              </div>
            </div>
          ) : personImg != null ? (
            <div className="relative w-[16%]">
              <img src={personImg} alt="workoutladey" />
              <div
                className="absolute w-[70%] flex items-center top-[5.5rem] -right-6"
                key={1}
              >
                <img src={line1} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[70%] flex items-center top-[8rem] -right-6"
                key={2}
              >
                <img src={line2} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[53%] flex items-center top-[10.7rem] -right-6"
                key={3}
              >
                <img src={line3} alt="workoutladey" />
              </div>
              <div
                className="absolute w-[60%] flex items-center top-[15.9rem] -right-6"
                key={4}
              >
                <img src={line4} alt="workoutladey" />
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="flex flex-col justify-center gap-5 w-3/12 mt-2 items-center">
            {bodyTarget &&
              bodyTarget?.map((option, index) => (
                <div
                  key={index}
                  className={`flex border gap-3 cursor-pointer rounded-2xl items-center w-full px-4 py-4 ${
                    option?.isTrue == true
                      ? "border-gray-200 !border-[#FF9950]"
                      : ""
                  } `}
                  onClick={() => {
                    handleToggle(index);
                    alert(option?.isTrue);
                  }}
                >
                  <div
                    className={`rounded-lg flex items-center justify-center w-7 h-7 border ${
                      option?.isTrue == true
                        ? " border-gray-200 bg-gray-300 bg-gray-100 !border-[#FF9950]"
                        : "ddd"
                    }`}
                  >
                    <img
                      src={check}
                      alt="check"
                      className={option?.isTrue == true ? "" : "hidden"}
                    />
                  </div>
                  <span className="text-xs font-medium text-capitalize">
                    {option.name}
                  </span>
                </div>
              ))}
          </div>
        </div>
        <button
          className="text-center w-10/12 mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl"
          onClick={PostPrefrencesData}
        >
          <p className="text-lg text-white font-medium">Update target</p>
        </button>
      </div>
    </div>
  );
}
